<template>
	<section class="course-desc pt-5 pb-4" id="teachlink">
		<div class="container py-md-3">
			<h3 class="heading mb-4 pb-3">专项测评</h3>
			<div class="content clearfix">
				<div class="card">
					<a target="_blank" class="card-course is-auth" @click="toTeach(1)">
						<div class="card-course-top hashadow"><img src="../../../../public/img/robot_test_l1.jpg" class="course-banner img-thumbnail"></div>
						<div class="course-card-content mt-1">
							<h3 class="course-card-name">机器人编程考试(一级)</h3></div>
					</a>
				</div>
				<div class="card">
					<a target="_blank" class="card-course is-auth" @click="toTeach(2)">
						<div class="card-course-top hashadow"><img src="../../../../public/img/robot_test_l2.jpg" class="course-banner img-thumbnail"></div>
						<div class="course-card-content mt-1">
							<h3 class="course-card-name">机器人编程考试(二级)</h3></div>
					</a>
				</div>
				<div class="card">
					<a target="_blank" class="card-course no-auth">
						<div class="card-course-top hashadow"><img src="../../../../public/img/robot_test_l3.jpg" class="course-banner img-thumbnail"></div>
						<div class="course-card-content mt-1">
							<h3 class="course-card-name">机器人编程考试(三级)</h3></div>
					</a>
				</div>
				<div class="card">
					<a target="_blank" class="card-course no-auth">
						<div class="card-course-top hashadow"><img src="../../../../public/img/robot_test_l4.jpg" class="course-banner img-thumbnail"></div>
						<div class="course-card-content mt-1">
							<h3 class="course-card-name">机器人编程考试(四级)</h3></div>
					</a>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import CommonHeader from '@/pages/common/Header'
	var header = CommonHeader
	export default {
		name: 'TestChapter',
		methods: {
			toTeach(sid) {
				if(this.$store.state.loginFlag) {
					this.$router.push({
						path: '/robot/course?sid=' + sid
					})
				} else {
					//					header.methods.login()
					this.$router.push({
						path: '/robot/course?sid=' + sid
					})
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/robot/components/TestChapter.scss';
</style>